import _ from "lodash";

export function getArrayFromString(nominalList) {
    if (!nominalList) {
        return [];
    }

    return nominalList.split(';').map(nominal => _.toNumber(nominal.trim().replace(',', '.')))
}